
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.389","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.389 6.426l-1.102-3.027a1.936 1.936 0 00-2.478-1.156l-2.026.738c0-.02.007-.04.009-.06A2.521 2.521 0 0012.745.507a2.615 2.615 0 00-4.131 1.72l-.29 1.867-1.5-1.323a2.615 2.615 0 00-3.479 3.905l.082.071-2.16.786a1.932 1.932 0 00-1.153 2.478l1.1 3.028 1.373-.5v7.524a1.928 1.928 0 001.927 1.936h12.89a1.936 1.936 0 001.934-1.934v-9.752H8.714zm-3.14-2.973a.645.645 0 01.826.385l.661 1.817-6.056 2.2-.882-2.423zm-6.36-1.032a1.326 1.326 0 012.094-.874 1.237 1.237 0 01-.329 2.207l-1.3.472-.793.288zm-.3 3.457l.88 2.421-1.211.441-.882-2.421zM4.701 3.464a1.316 1.316 0 011.274.272l1.671 1.477-2.1.763a1.307 1.307 0 01-1.332-.26 1.326 1.326 0 01.487-2.252zM1.99 11.387L1.329 9.57a.644.644 0 01.385-.826L7.165 6.76l.882 2.423zm10.906.215h5.165v8.465a.653.653 0 01-.653.645h-4.512zm-2.578 0h1.296v9.109h-1.3zm-1.28 0v9.109H4.514a.645.645 0 01-.645-.645v-7.993l1.3-.472z","fill":"#fff"}})])
          )
        }
      }
    